import { useEffect, useState } from 'react'

export const PLAYERS_COUNT = 4

export enum Color {
  BLUE = 'BLUE',
  YELLOW = 'YELLOW',
  RED = 'RED',
  PURPLE = 'PURPLE',
  GREEN = 'GREEN',
}

export interface IColorScore {
  count: number
  multiplier: number
}

export type ColorScores = Array<{ [color in Color]: IColorScore }>

export function useGame() {
  const [colorScores, setColorScores] = useState<ColorScores>(getInitialColorScores())
  const [stoneScores, setStoneScores] = useState<number[]>(Array.from({ length: PLAYERS_COUNT }).map((_value) => 0))
  const [totalScores, setTotalScores] = useState<number[]>(Array.from({ length: PLAYERS_COUNT }).map((_value) => 0))

  function getInitialColorScores(): ColorScores {
    return Array.from({ length: PLAYERS_COUNT }).map((_value) => ({
      [Color.BLUE]: { count: 0, multiplier: 0 },
      [Color.YELLOW]: { count: 0, multiplier: 0 },
      [Color.RED]: { count: 0, multiplier: 0 },
      [Color.PURPLE]: { count: 0, multiplier: 0 },
      [Color.GREEN]: { count: 0, multiplier: 0 },
    }))
  }

  useEffect(() => {
    const result: number[] = []

    for (let i = 0; i < PLAYERS_COUNT; i++) {
      result.push(
        stoneScores[i] + Object.values(colorScores[i]).reduce((acc, score) => acc + score.count * score.multiplier, 0),
      )
    }

    setTotalScores(result)
  }, [colorScores, stoneScores])

  function setColorScore(index: number, type: keyof IColorScore, color: Color, value: number) {
    const copy = { ...colorScores }

    copy[index][color][type] = value

    setColorScores(copy)
  }

  function setStoneScore(index: number, value: number) {
    const copy = [...stoneScores]

    copy[index] = value

    setStoneScores(copy)
  }

  return { colorScores, stoneScores, totalScores, setColorScore, setStoneScore }
}
